import controller from './view.controller';
import template from './view.pug';

const ViewComponent = {
  template,
  controller,
  bindings: {
    case: '<',
  },
};

export default ViewComponent;



// WEBPACK FOOTER //
// ./client/app/cases/view/view.component.js